var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("rect",{"height":"54.05","rx":"7.07","width":"79.81","x":"2","y":"2","key":0}),React.createElement("path",{"d":"m4.01 54.34 26.81-24.24","key":1}),React.createElement("path",{"d":"m79.86 54.28-26.38-23.82","key":2}),React.createElement("path",{"d":"m80.05 3.83-34.69 34.66a4.36 4.36 0 0 1 -6.16 0l-35-35","key":3})]));
}

Envelope.defaultProps = {"viewBox":"0 0 83.81 58.05"};

module.exports = Envelope;

Envelope.default = Envelope;
